import { SceneName } from "../constants";

export default class IntroCardScene extends Phaser.Scene {
  constructor() {
    super(SceneName.IntroCardScene);
  }

  create() {
    this.cameras.main.flash(200, 255, 255, 255);
    this.time.delayedCall(1500, () => {
      this.cameras.main.fadeOut(1600, 0, 0, 0);
    });

    this.time.delayedCall(3200, () => {
      this.scene.start(SceneName.MapScene);
    });

    const text = this.add.text(
      64,
      114,
      `Game saves automatically\n after level completion.`,
      {
        fontFamily: "sins",
        fontSize: "16px",
        align: "center",
      }
    );

    text.setOrigin(0.5);
    text.setResolution(10);
  }
}
